import React from "react";
import SuccessModal from "../../../../../organisms/Modal/SuccessModal/SuccessModal";
import ErrorModal from "../../../../../organisms/Modal/ErrorModal/ErrorModal";
import {NoSsr} from "@material-ui/core";
import {compose} from "recompose";
import {withTranslation} from "react-i18next";
let t=null;

class ChannelSetupStatus extends React.Component {

    constructor(props){
        super(props);
        t = props.t;
    }

    showMessages = () => {

        if( this.props.channelSetup.channelSetupSubmitData && this.props.channelSetup.channelSetupSubmitData.status === 200 ){
            return <SuccessModal status={true} message={ t('enw-notification_saved_successfully') } />
        } else if (this.props.channelSetup && this.props.channelSetup.submitError.response !== undefined )  {
            let message = this.props.channelSetup.submitError.response.data.message
            return  <ErrorModal status={true} message={message}/>
        }
    }

    render() {
        return (
            <NoSsr>
                {
                    !this.props.channelSetup.fetching &&
                        <NoSsr>
                            {
                                this.showMessages()
                            }
                        </NoSsr>
                }

            </NoSsr>
        )
    }
}

export default compose(withTranslation('common')) (ChannelSetupStatus);
